
define('template!ordersDetailOrderProductOptionEditMixableOptionsView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="header">\n    ';
 _.each(categories, function(category) { ;
__p += '\n        <div class="category">' +
((__t = ( category.name )) == null ? '' : __t) +
'</div>\n    ';
 }); ;
__p += '\n\n    <div class="quantity">' +
((__t = ( _.i18n("common.quantity") )) == null ? '' : __t) +
'</div>\n    <div class="delete-button">' +
((__t = ( _.i18n("delete") )) == null ? '' : __t) +
'</div>    \n</div>\n<div class="collection-region"></div>';

}
return __p
};});

